import Icons, { IconsProps } from '../../Icons';

export type TaskAltProps = IconsProps;

/**
 * - sm
 *   - 0.875 rem 14 px
 * - md (defalut)
 *   - 1 rem 16 px
 * - lg
 *   - 1.125 rem 18 px
 * - xl
 *   - 1.25 rem 20 px
 * - xl2 (big)
 *   - 1.5 rem 24 px
 * @param props
 * @returns
 */
export function TaskAlt(props: TaskAltProps) {
  return (
    <Icons {...props}>
      <path d="M12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.0167 3 13.9833 3.15833 14.9 3.475C15.8167 3.79167 16.65 4.23333 17.4 4.8L16.675 5.55C16.025 5.05 15.3043 4.66667 14.513 4.4C13.721 4.13333 12.8833 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20C14.2167 20 16.1043 19.221 17.663 17.663C19.221 16.1043 20 14.2167 20 12C20 11.6 19.971 11.204 19.913 10.812C19.8543 10.4207 19.7667 10.0417 19.65 9.675L20.45 8.875C20.6333 9.35833 20.771 9.86233 20.863 10.387C20.9543 10.9123 21 11.45 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM10.55 15.9L7 12.35L7.7 11.65L10.55 14.5L20.3 4.75L21 5.475L10.55 15.9Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
